import React from 'react'

import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon } from '@radix-ui/react-icons'
import { MinusIcon } from '@heroicons/react/24/solid'
import { cn } from '@/utils'

export const Checkbox = React.forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    className?: string
    indeterminate?: boolean
  }
>(({ className, checked, indeterminate, ...props }, ref) => {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      checked={indeterminate ? true : checked}
      className={cn(
        'group flex h-4 w-4 items-center justify-center rounded border border-gray-300 bg-white data-[state=checked]:bg-primary-50 data-[state=checked]:border-primary-50 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="h-full w-full flex items-center justify-center">
        {indeterminate ? (
          <MinusIcon className="h-3 w-3 text-white" />
        ) : (
          <CheckIcon className="h-full w-full text-white" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
})

Checkbox.displayName = CheckboxPrimitive.Root.displayName
